import { EMissingKYCStatus } from "../../types/payment.types";
import { normalizeDate } from "../date-fns.utils";
import { formatDate } from "../date.utils";
import { getLocalizedText } from "../i18n/i18n.utils";
export var MISSING_KYC_RENEWAL_PENDING_REASON_KEY = "payments.collection.follow_up.reason.renewal_pending";
export var MISSING_KYC_RENEWAL_PENDING_REASON_KEY_NO_DEADLINE = "payments.collection.follow_up.reason.renewal_pending.no_deadline";
/**
 * Whether the broker can still start or restart this beneficiary's KYC.
 *
 * `renewalPending` is Mangopay's proactive renewal window: the beneficiary is
 * still validated and payouts still run, but the identity document expires on
 * `kycRenewalDeadline` and a new one has to be submitted before then - so the
 * action has to be available for the whole window.
 */
export var canPerformKyc = function (status) {
    return [
        EMissingKYCStatus.None,
        EMissingKYCStatus.New,
        EMissingKYCStatus.Failed,
        EMissingKYCStatus.RenewalPending,
    ].includes(status);
};
export var getMissingKycAppearance = function (status) {
    switch (status) {
        case EMissingKYCStatus.Requested:
            return "info";
        case EMissingKYCStatus.Approved:
            return "success";
        // Nothing is broken yet - payouts keep running until the deadline passes -
        // so this ranks below the failure states but above the informational ones.
        case EMissingKYCStatus.RenewalPending:
            return "warning";
        case EMissingKYCStatus.None:
        case EMissingKYCStatus.New:
        case EMissingKYCStatus.Failed:
        default:
            return "error";
    }
};
/**
 * The reason line for a beneficiary inside the renewal window.
 *
 * The deadline is nullable on the wire (a pspInfo row created mid-window
 * carries none) and arrives as an ISO string despite the `Date` type, so both
 * cases get copy of their own rather than a stray `{{date}}` or a RangeError
 * out of `format`.
 */
export var getMissingKycRenewalPendingReason = function (kycRenewalDeadline) {
    // The short-circuit handles null/undefined - neither is in TDate, so
    // normalizeDate never sees them; normalizeDate is what turns the ISO string
    // the API actually sends into a Date.
    var deadline = kycRenewalDeadline && normalizeDate(kycRenewalDeadline);
    if (!deadline || Number.isNaN(deadline.getTime())) {
        return getLocalizedText(MISSING_KYC_RENEWAL_PENDING_REASON_KEY_NO_DEADLINE);
    }
    return getLocalizedText(MISSING_KYC_RENEWAL_PENDING_REASON_KEY, {
        date: formatDate(deadline),
    });
};
